import { createStore, stateSetterHandler } from '@alpha.apps/react-common';

export type CinemaState = {
  selectedCinemas: number[];
};

const initState: CinemaState = {
  selectedCinemas: [],
};

export const useCinemas = createStore({
  name: 'cinemas',
  devtools: true,
  persist: false,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setSelectedCinemas: handler('selectedCinemas'),
  };
});
